<template>
	<div>
		<app-total
			:start="pagination.offset"
			:end="pagination.offset + payments.array.length"
			:total="payments.count"
		/>
		<div>
			<md-table v-model="array" v-if="array.length > 0">
				<md-table-row
					:key="item.id"
					slot="md-table-row"
					slot-scope="{ item }"
					md-selectable="single"
					@click="rowClick(item)"
				>
					<md-table-cell width="25" v-if="selecteds">
						<md-checkbox
							:id="item.id"
							v-model="selecteds"
							:value="item"
							@click="e => e.stopPropagation()"
						/>
					</md-table-cell>
					<md-table-cell :md-label="$t('status')" width="100">
						<el-tag v-if="new Date(item.valid_from) > new Date()" effect="dark">{{ $t("waiting") }}</el-tag>
						<el-tag v-else-if="new Date(item.valid_until) > new Date()" effect="dark" type="success">{{
							$t("active")
						}}</el-tag>
						<el-tag v-else effect="dark" type="danger">{{ $t("expired") }}</el-tag>
					</md-table-cell>
					<md-table-cell :md-label="$t('valid-from')" width="150">
						<span>{{ moment(item.valid_from).format("DD/MM/YYYY") }}</span>
					</md-table-cell>
					<md-table-cell :md-label="$t('valid-until')" width="150">
						<span :style="{ color: new Date(item.valid_until) < new Date() ? 'red' : '' }">
							{{ moment(item.valid_until).format("DD/MM/YYYY") }}
						</span>
					</md-table-cell>
					<md-table-cell :md-label="$t('school')">{{ item.organization.name.String }}</md-table-cell>
					<md-table-cell :md-label="$t('subscription')">{{ item.subscription.name }}</md-table-cell>
					<md-table-cell :md-label="$t('amount')" width="150">{{
						"€ " + item.amount.toFixed(2)
					}}</md-table-cell>
					<md-table-cell :md-label="$t('bought-at')" width="100">
						{{ moment(item.created_at).format("DD/MM/YYYY") }}
					</md-table-cell>
				</md-table-row>
			</md-table>
			<div v-else>
				<p>{{ $t("empty-result") }}</p>
			</div>
		</div>
		<app-pagination :offset="pagination.offset" :size="pagination.size" :tot="payments.count" @fetch="doFetch" />
	</div>
</template>
<script>
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import AppTotal from "@/modules/_common/table/app-total.vue"
import AppPagination from "@/modules/_common/table/app-pagination.vue"

export default {
	components: {
		AppTotal,
		AppPagination
	},
	name: "payments-table",
	props: ["selecteds"],
	data() {
		return {
			array: []
		}
	},
	mounted() {
		this.array = this.payments.array
	},
	computed: {
		...mapGetters({
			payments: "payment/payments",
			pagination: "payment/pagination"
		})
	},
	methods: {
		...mapActions({
			doMutate: "payment/doMutate"
		}),
		rowClick: function (item) {
			this.doMutate({ element: "payment", value: item })
			this.$router.push({ path: "/users/payments/" + item.id })
		},

		doFetch: function (page, size) {
			var f = { ...this.pagination }
			if (size) f.size = size
			if (page) f.offset = (page - 1) * this.pagination.size
			this.doMutate({ element: "pagination", value: f })
			this.$emit("fetch", f)
		}
	},
	watch: {
		payments: function () {
			this.array = this.payments.array
		}
	}
}
</script>
<style scoped></style>
